import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { TableBodyCell } from '../TableCell';
const rankingStyles = css({
  boxSizing: 'border-box'
});
export const RankableTableBodyCell = ({
  isRanking,
  innerRef,
  ...props
}) => jsx(TableBodyCell, _extends({
  css: isRanking && rankingStyles
}, props, {
  innerRef: innerRef
}));